// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


/*==================================================
    //Home map 
==================================================*/
// Au hover sur les différentes villes (SVG)
const citiesMap = document.querySelectorAll('.home-map svg a'); // on sélectionne dans le DOM toutes les villes contenues dans le SVG

citiesMap.forEach(city => { // on itère sur le tableau citiesMap
    city.addEventListener('mouseover', (event) => { // à chaque SVG de ville survolé
        let currentCityClass = event.currentTarget.getAttribute('class'); // on récupère la class de la ville survolée
        document.querySelector('.home-map__list a.' + currentCityClass).classList.add('ville_hover'); // on ajoute la classe ville_hover au nom de ville concerné pour avoir la couleur renseignée en CSS
    });

    city.addEventListener('mouseout', (event) => { // si on ne survole plus la ville en question
        let currentCityClass = event.currentTarget.getAttribute('class');
        document.querySelector('.home-map__list a.' + currentCityClass).classList.remove('ville_hover'); // on remove la class
    });
});


// Au hover sur les différentes villes (Text)
const citiesNames = document.querySelectorAll('.home-map__list a'); // on sélectionne tous les noms des villes

citiesNames.forEach(city => { // on itère sur le tableau citiesNames
    city.addEventListener('mouseover', (event) => { // à chaque nom de ville survolé
        let currentCityClass = event.currentTarget.getAttribute('class'); // on récupère la class de la ville survolée
        document.querySelector('.home-map svg a.' + currentCityClass + ' path').classList.add('map_hover'); // on ajoute la classe map_hover au path concerné pour avoir la couleur renseignée en CSS
    });

    city.addEventListener('mouseout', (event) => { // si on ne survole plus le nom de ville en question
        let currentCityClass = event.currentTarget.getAttribute('class');
        document.querySelector('.home-map svg a.' + currentCityClass + ' path').classList.remove('map_hover'); // on remove la class
    });
});




//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})
